const initialStateCity = {
  isLoading: false,
  profile: {},
  errors: null,
};
const profilereducer = (state = initialStateCity, action) => {
  switch (action.type) {
    case "profile_req":
      return {
        ...state,
        isLoading: true,
      };
    case "profile_success":
      return {
        ...state,
        isLoading: false,
        profile: action.payload,
      };
    case "profile_failure":
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
      };
    case "update_profile_req":
      return {
        ...state,
        isLoading: true,
      };
    case "update_profile_success":
      return {
        ...state,
        isLoading: false,
        profile: action.payload,
      };
    case "update_profile_failure":
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
      };
    default:
      return state;
  }
};
export { profilereducer };
